/**
 * Checks if a given object has a key.
 *
 * @param key - The key you want to check.
 * @param object - The object you want to check.
 * @returns True if the key exists, false if it doesn't.
 */

export function isKeyOf<T extends object>(key: number | string | symbol, object: T): key is keyof T {
  return key in object;
}
